import { useState } from 'react';
import { login, forgotPassword } from '../api';

export default function LoginPage({ onLogin }) {
  const [mode, setMode]         = useState('login');
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [email, setEmail]       = useState('');
  const [error, setError]       = useState('');
  const [sent, setSent]         = useState(false);
  const [loading, setLoading]   = useState(false);

  async function doLogin(e) {
    e.preventDefault(); setError(''); setLoading(true);
    try { await login(username, password); onLogin(); }
    catch (err) { setError(err.message); }
    finally { setLoading(false); }
  }

  async function doForgot(e) {
    e.preventDefault(); setError(''); setLoading(true);
    try { await forgotPassword(email); setSent(true); }
    catch (err) { setError(err.message); }
    finally { setLoading(false); }
  }

  return (
    <div style={{ padding:'44px 24px', maxWidth:380, margin:'0 auto' }}>
      <div style={{ textAlign:'center', marginBottom:28 }}>
        <img src="/img/logo-equipote.png" alt="Équipote" style={{ height:48, width:'auto', margin:'0 auto 6px', display:'block' }} />
        <h1 style={{ fontFamily:'Barlow Condensed', fontSize:24, fontWeight:800, marginTop:8 }}>
          {mode === 'login' ? 'Connexion' : 'Mot de passe oublié'}
        </h1>
      </div>

      {mode === 'login' ? (
        <form onSubmit={doLogin}>
          <div className="form-group">
            <label>Identifiant</label>
            <input type="text" value={username} onChange={e=>setUsername(e.target.value)}
              autoComplete="username" autoCapitalize="none" required />
          </div>
          <div className="form-group">
            <label>Mot de passe</label>
            <input type="password" value={password} onChange={e=>setPassword(e.target.value)}
              placeholder="••••••••" autoComplete="current-password" required />
          </div>
          {error && <div style={{ background:'rgba(var(--danger-rgb),0.1)', border:'1px solid rgba(var(--danger-rgb),0.3)',
            borderRadius:8, padding:'10px 14px', color:'var(--danger)', fontSize:13, marginBottom:14 }}>{error}</div>}
          <button type="submit" className="btn btn-primary" disabled={loading}>
            {loading ? 'Connexion…' : 'Se connecter'}
          </button>
          <button type="button" onClick={()=>{setMode('forgot');setError('');}}
            style={{ width:'100%', background:'none', border:'none', color:'#8b949e', fontSize:12,
              cursor:'pointer', marginTop:14, padding:8 }}>
            Mot de passe oublié ?
          </button>
        </form>
      ) : sent ? (
        <div style={{ textAlign:'center' }}>
          <div style={{ fontSize:36, marginBottom:12 }}>📧</div>
          <p style={{ fontSize:14, lineHeight:1.7 }}>
            Si un compte existe avec cette adresse, un email vient d'être envoyé avec un lien pour choisir un nouveau mot de passe.
          </p>
          <p style={{ color:'#8b949e', fontSize:12, marginTop:10 }}>Le lien est valable 1 heure.</p>
          <button className="btn btn-secondary" style={{ marginTop:20 }}
            onClick={()=>{setMode('login');setSent(false);setEmail('');}}>← Retour</button>
        </div>
      ) : (
        <form onSubmit={doForgot}>
          <p style={{ fontSize:13, color:'#8b949e', marginBottom:16, lineHeight:1.6 }}>
            Saisis l'adresse email associée à ton compte, tu recevras un lien pour choisir un nouveau mot de passe.
          </p>
          <div className="form-group">
            <label>Email</label>
            <input type="email" value={email} onChange={e=>setEmail(e.target.value)}
              placeholder="ton@email.fr" autoComplete="email" required />
          </div>
          {error && <div style={{ background:'rgba(var(--danger-rgb),0.1)', border:'1px solid rgba(var(--danger-rgb),0.3)',
            borderRadius:8, padding:'10px 14px', color:'var(--danger)', fontSize:13, marginBottom:14 }}>{error}</div>}
          <button type="submit" className="btn btn-primary" disabled={loading}>
            {loading ? 'Envoi…' : 'Envoyer le lien'}
          </button>
          <button type="button" onClick={()=>{setMode('login');setError('');}}
            style={{ width:'100%', background:'none', border:'none', color:'#8b949e', fontSize:12,
              cursor:'pointer', marginTop:14, padding:8 }}>
            ← Retour à la connexion
          </button>
        </form>
      )}
      <p style={{ textAlign:'center', marginTop:28, fontSize:13, color:'var(--muted)', lineHeight:1.6 }}>
        Votre club n'utilise pas encore Équipote ?<br/>
        <a href="/?inscription" style={{ color:'var(--accent)', fontWeight:700 }}>Essayer gratuitement pendant un mois</a>
      </p>
    </div>
  );
}
